import React from "react";
import { Droppable } from "react-beautiful-dnd";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import DragItem from "../drag-item";

const BackEndColumn = ({ column }) => (
  <div
    style={{
      border: "1px solid lightgrey",
      borderRadius: "5px",
      flexGrow: 1,
      padding: 5,
      width: "40%",
      minHeight: 0,
      overflow: "hidden"
    }}>
    <div style={{ overflowY: "auto", overflowX: "hidden", padding: 15, height: "100%" }}>
      <Typography fontSize="19px!important" variant="h5">
        {column.name}
      </Typography>
      <Droppable droppableId={column.id}>
        {(provided) => (
          <List style={{ width: "100%", height: "100%" }} ref={provided.innerRef} {...provided.droppableProps}>
            {column.list.map((itemObject, index) => (
              <DragItem key={itemObject.columnName} itemObject={itemObject} index={index} />
            ))}
            {provided.placeholder}
          </List>
        )}
      </Droppable>
    </div>
  </div>
);

export default BackEndColumn;
